import { Resources } from "@app/resources";
import { BuildingPlanComponent } from "@modules/building-plan/pages/building-plan/building-plan.component";

export default {
  path: Resources.BuildingPlan,
  component: BuildingPlanComponent
}
